var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWeight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41 4H7C6.20435 4 5.44129 4.31607 4.87868 4.87868C4.31607 5.44129 4 6.20435 4 7V41C4 41.7956 4.31607 42.5587 4.87868 43.1213C5.44129 43.6839 6.20435 44 7 44H41C41.7956 44 42.5587 43.6839 43.1213 43.1213C43.6839 42.5587 44 41.7956 44 41V7C44 6.20435 43.6839 5.44129 43.1213 4.87868C42.5587 4.31607 41.7956 4 41 4V4Z",
    stroke: "#7A51AE",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 19.0537C15.325 15.0537 19.325 13.0537 24 13.0537C28.675 13.0537 32.675 15.0537 36 19.0537",
    stroke: "#7A51AE",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 31C24.7956 31 25.5587 30.6839 26.1213 30.1213C26.6839 29.5587 27 28.7956 27 28C27 27.2044 26.6839 26.4413 26.1213 25.8787C25.5587 25.3161 24.7956 25 24 25C23.2044 25 22.4413 25.3161 21.8787 25.8787C21.3161 26.4413 21 27.2044 21 28C21 28.7956 21.3161 29.5587 21.8787 30.1213C22.4413 30.6839 23.2044 31 24 31Z",
    fill: "#7A51AE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 21L24.008 28",
    stroke: "#7A51AE",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeight);
export default __webpack_public_path__ + "static/media/weight.2a95329a8ec2184dedea0405d7383ce3.svg";
export { ForwardRef as ReactComponent };